import { IconKeys } from '../Icon/IconKeys';
import { AlertRisksKeys } from '../../../API/types/Alerts';
import { ThemeType } from '../../../theme/themeType';
import { generateColorBasedOnRisk } from '../../../pages/AlertDetails/helpers';
import { CalendarItemType, iconKeysByType } from './types';

const isAlertRisk = (value?: string): value is AlertRisksKeys => (
  value === 'urgent' || value === 'medium' || value === 'low'
);

export const getTimelineIconKey = (item?: CalendarItemType): IconKeys => (
  iconKeysByType[item?.type || 'alert'] || IconKeys.LIGHTNING
);

export const getTimelineIconColor = (
  item: CalendarItemType | undefined,
  theme: ThemeType,
): string => {
  if (item?.type === 'alert') {
    return isAlertRisk(item.riskLevel)
      ? generateColorBasedOnRisk(item.riskLevel, theme)
      : theme.colors.inactive;
  }

  if (item?.tripPhase === 'end') {
    return theme.colors.inactive;
  }

  return theme.colors.main_cta;
};
